import { legacyPageEntrypoint } from '@atlassian/jira-router-routes-legacy-page-entrypoint/src/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createLegacyEntry } from '@atlassian/jira-route-entry/src/createLegacyEntry.tsx';
import { legacyPersonalSettingsAccessTokensRoute } from '@atlassian/jira-router-routes-legacy-personal-settings-access-tokens-routes/src/legacyPersonalSettingsAccessTokensRoute.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const legacyPersonalSettingsAccessTokensRouteEntry = createLegacyEntry(
	legacyPersonalSettingsAccessTokensRoute,
	() => ({
		layout: globalLayout,
		entryPoint: () => pageEntryPoint,
	}),
);
